import BusinessLogo from './business-logo'
import BusinessLogoActions from './business-logo/actions'
import BusinessLogoControls from './business-logo/controls'
import SiteColors from './site-colors'
import SiteColorsAction from './site-colors/actions'
import SiteColorsControls from './site-colors/controls'
import SiteTypography from './site-typography'
import SiteTypographyActions from './site-typography/actions'
import SiteTypographyControls from './site-typography/controls'
import Congratulations from './congratulations'
import CongratulationsActions from './congratulations/actions'

export const CustomizeSteps = [
	{
		content: BusinessLogo,
		controls: BusinessLogoControls,
		actions: BusinessLogoActions,
		class: 'customize-business-logo',
	},
	{
		content: SiteColors,
		controls: SiteColorsControls,
		actions: SiteColorsAction,
		class: 'customize-site-colors',
	},
	{
		content: SiteTypography,
		controls: SiteTypographyControls,
		actions: SiteTypographyActions,
		class: 'customize-site-typography',
	},
	{
		content: Congratulations,
		controls: '',
		actions: CongratulationsActions,
		class: 'congratulations',
	}
]
